import './scoreboard.css';

const ScoreBoard = ({ scoreBoard, eventType }) => {
  if (!scoreBoard) return null;

  const {
    spnnation1,
    spnnation2,
    spnballrunningstatus,
    score1,
    score2,
    activenation1,
    activenation2,
    balls,
    spnrunrate1,
    spnrunrate2
  } = scoreBoard;

  const getBallStatusText = (status) => {
    switch (status) {
      case 'o':
        return "Over End";
      case 'B':
        return "Ball Running";
      case 'w':
        return "Wicket";
      case '^2':
        return "";
      case 'nb':
        return "No Ball";
      default:
        return status || "";
    }
  };

  return (
    <div id="scoreboard-box" className='col-span-12'>
      {eventType === 4 && (
        <div className="score-main" id="score-main">
          <div className="score-body bg-[#000]" >
            <div className="row row-for-score" style={{ background: 'none' }}>
              <div className="col-md-8 teams-status">
                <div className="teams-name">
                  <span
                    id="a_team_name"
                    className={`${activenation1 === '1' ? 'active-score' : 'inactive-score'} bold-font-class`}
                  >
                    {spnnation1 || ""}
                  </span>
                  <span
                    id="b_team_name"
                    className={`${activenation2 === '1' ? 'active-score' : 'inactive-score'} bold-font-class`}
                  >
                    {spnnation2 || ""}
                  </span>
                </div>
                <div id="targetdiv">
                  <span
                    id="a_team_live_score"
                    className={`${activenation1 === '1' ? 'active-score' : 'inactive-score'} bold-font-class`}
                    style={{ float: 'right' }}
                  >
                    {score1 || ""} {spnrunrate1 ? 'CRR ' + spnrunrate1 : ''}
                  </span>
                  <span
                    id="b_team_live_score"
                    className={`${activenation2 === '1' ? 'active-score' : 'inactive-score'} bold-font-class`}
                    style={{ float: 'right' }}
                  >
                    {score2 || ""} {spnrunrate2 ? 'CRR ' + spnrunrate2 : ''}
                  </span>
                </div>
              </div>
              <div className="col-md-4 ball_status_update" id="statuswidth">
                <span id="ball-status">{getBallStatusText(spnballrunningstatus)}</span>
              </div>
            </div>
            <div className="ball-update">
              <span style={{ fontSize: '14px' }}>Last 6 balls: </span>
              <ul className="lt" id="balls-list" style={{ marginLeft: '5px' }}>
                {balls && balls.length > 0 ? (
                  balls.map((ball, index) => (
                    <li
                      key={`ball-${index}`}
                      className={`ball-runs ball_${ball}`}
                      id={`ovball${index}`}
                    >
                      {ball}
                    </li>
                  ))
                ) : (
                  <span>Score Board Not Available Before Match!</span>
                )}
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ScoreBoard;